<div
    class="dates-selector"
    [ngClass]="{ active: !readonly, 'not-valid': isNotValid }"
>
    <div>
        <div class="row">
            <div class="col-8">
                <div class="row dates-row">
                    @for (date of allowedDates; track date) {
                        <div
                            hznTestId="dates-selector-date"
                            (click)="onSelectClicked(date)"
                            class="date-btn"
                            [ngClass]="{
                                'date-selected': isSelected(date),
                                'date-not-selected': !isSelected(date),
                            }"
                        >
                            <div>{{ date | bcDate: "DD" }}</div>
                            <div>{{ date | bcDate: "MMMM" }}</div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
